import { SOCIAL_ACCOUNT_KEYS, SOCIAL_PLATFORMS, SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';

export const addSocialChannelV1RequestSchema = z.object({
  provider: z.enum(SOCIAL_PROVIDERS),
  platform: z.enum(SOCIAL_PLATFORMS),
  // Which aggregator account owns this channel; defaults to 'default' server-side.
  accountKey: z.enum(SOCIAL_ACCOUNT_KEYS).optional(),
  providerAccountId: z.string(),
  displayName: z.string(),
  handle: z.string().optional(),
});

export type IAddSocialChannelV1Request = z.infer<typeof addSocialChannelV1RequestSchema>;
